export const componentHasPropTypes = (requiredPropTypes) => {

  return (props, propName, componentName) => {
    if (props[propName]) {
      const prop = props[propName];
      let widgetName = prop.type.name;
      let propTypes = prop.type.propTypes || {};
      if (prop.type.WrappedComponent) { // For containers, check the propTypes of the WrappedComponent
        widgetName = prop.type.WrappedComponent.name;
        propTypes = prop.type.WrappedComponent.propTypes || {};
      }
      let missingProps = [];
      requiredPropTypes.forEach((requiredProp) => {
        if (!propTypes[requiredProp]) {
          missingProps.push(requiredProp);
        }
      });
      if (missingProps.length > 0) {
        return new Error(
          '`' + componentName + '`. ' +
          'The component passed as ' +
          '`' + propName + '` ' +
          '(' + widgetName + ') is missing the following PropType(s): ' +
          missingProps
        );
      }
    }
    //assume all ok
    return null;
  };
};


// WEBPACK FOOTER //
// ./src/utils/CustomPropTypeValidation.js